export const togglebutton = {
  root: {
    padding: "{padding.6}",
    borderRadius: "{content.border.radius}",
    // gap: "0",
    fontWeight: "500",
    disabledBackground: "{form.field.disabled.background}",
    disabledBorderColor: "{form.field.disabled.background}",
    disabledColor: "{form.field.disabled.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
    transitionDuration: "{form.field.transition.duration}",
    // sm: {
    //   fontSize: "{form.field.sm.font.size}",
    //   padding: "0.25rem",
    // },
    // lg: {
    //   fontSize: "{form.field.lg.font.size}",
    //   padding: "0.25rem",
    // },
  },
  content: {
    padding: "{padding.4} {padding.10}",
    borderRadius: "{content.border.radius}",
    checkedShadow: "none",
    // sm: {
    //   padding: "0.25rem 0.75rem",
    // },
    // lg: {
    //   padding: "0.25rem 0.75rem",
    // },
  },
  // icon: {
  //   disabledColor: "{form.field.disabled.color}",
  // },
  colorScheme: {
    light: {
      root: {
        background: "{surface.bg-grey-contrast}",
        checkedBackground: "{surface.bg-grey-contrast}",
        hoverBackground: "{surface.bg-grey-contrast}",
        borderColor: "{surface.bg-grey-contrast}",
        color: "{text.caption}",
        hoverColor: "{text.body}",
        checkedColor: "{text.body}",
        checkedBorderColor: "{surface.bg-grey-contrast}",
      },
      content: {
        checkedBackground: "{surface.bg-white}",
      },
      // icon: {
      //   color: "{surface.500}",
      //   hoverColor: "{surface.700}",
      //   checkedColor: "{surface.900}",
      // },
    },
    dark: {
      root: {
        background: "{surface.bg-grey-contrast}",
        checkedBackground: "{surface.bg-grey-contrast}",
        hoverBackground: "{surface.bg-grey-contrast}",
        borderColor: "{surface.bg-grey-contrast}",
        color: "{text.caption}",
        hoverColor: "{text.body}",
        checkedColor: "{text.body}",
        checkedBorderColor: "{surface.bg-grey-contrast}",
      },
      content: {
        checkedBackground: "{surface.bg-white}",
      },
      // icon: {
      //   color: "{surface.500}",
      //   hoverColor: "{surface.700}",
      //   checkedColor: "{surface.900}",
      // },
    },
  },
  extend: {
    ui: {
      fontLeading: "{form.field.font.leading}",
    },
  },
  css: ({ dt }: any): string => `
    .p-togglebutton {
      line-height: ${dt("togglebutton.ui.font.leading")};
    }
  `,
};
